module.exports = __webpack_public_path__ + "assets/img/modal-avatar-bc834f76.png";